export const ENGLISH_TRANSLATIONS = {
  text: {
    book_a_reservation: 'Book A Reservation',
    date_of_visit: 'Date of Visit',
    required: 'Required',
    daily_max: 'Exceeded daily max',
    min_date: 'Reservations allowed on or after',
    max_date: 'Date too far out',
    blackout_date: 'Date not available',
    disabled_date: 'Please select a different date',
    location: 'Location',
    locations: 'Locations',
    select_location: 'Select Location',
    location_not_allowed: 'Location is not allowed',
    too_far_from_location: 'You are too far from the location',
    entrance: 'Entrance',
    select_entrance: 'Select Entrance',
    entrance_not_allowed: 'Entrance is not allowed',
    select_location_first: 'Select Location First',
    timeslot: 'Timeslot',
    select_timeslot: 'Select Timeslot',
    timeslot_not_allowed: 'Timeslot is not allowed',
    group_size: 'Group Size',
    select_group_size: 'Select Group Size',
    group_size_not_allowed: 'Group size is not allowed',
    name: 'Name',
    name_length: 'Must be between 2 and 64 characters',
    email: 'Email',
    email_valid: 'Please enter a valid email',
    phone: 'Phone',
    phone_number: 'Phone Number',
    phone_number_valid: 'Please enter a valid phone number',
    notes_valid: 'Must be between 1 and 2048 characters',
    agree: 'I agree to',
    agree_full: 'I agree to the full',
    and: 'and',
    terms_and_conditions: 'terms and conditions',
    book_reservation: 'Book Reservation',
    continue: 'Continue',
    back: 'Back',
    manage_reservations: 'Manage Reservations',
    upcoming_reservations: 'Upcoming Reservations',
    reservation_details: 'Reservation Details',
    access: 'Access',
    thank_you: 'Thank you for reserving',
    qr_sent: 'A QR code link has been sent to your',
    present_qr: 'Please present your QR code upon arrival at the location.',
    important_notes: 'Important Notes',
    arrive_by: 'Please arrive at the location by',
    use_the: 'Please use the',
    leave_location_by: 'You must leave the location by',
    new_reservation: 'New Reservation',
    location_check_in: 'Location Check In',
    you_are_checked_in: 'You are checked in to the location',
    check_out: 'Check Out Of Location',
    reservation: 'Reservation',
    modify_reservation: 'Modify Reservation',
    cancel_reservation: 'Cancel Reservation',
    time: 'Time',
    time_remaining: 'Time Remaining',
    expiration_date: 'Expiration Date',
    number_of_people: '# of People',
    at_the_location: 'at the location',
    view_reservation: 'View Reservation',
    notes: 'Notes',
    select_date_first: 'Select Date First',
    are_you_sure: 'Are you sure?',
    are_you_sure_cancel: 'Are you sure you want to cancel your reservation?',
    close: 'Close',
    reservation_error: 'We encountered an error',
    reservation_create_error_message:
      'Sorry, we encountered an error when trying to make your reservation. Please click the button below to try again.',
    reservation_cancel_error_message:
      'Sorry, we encountered an error when trying to cancel your reservation. Please click the button below to try again.',
    try_again: 'Try Again',
    long_term_reservations: 'Long Term Reservations',
    main: 'Main',
    add_to_calendar: 'ADD TO CALENDAR',
    reservation_at: 'Reservation at',
    all_day: 'All Day',
    enter_phone_number: 'Enter a phone number',
    not_allowed: 'Not Authorized',
    not_allowed_message: 'You are not authorized to use this link.',
    automatic_check_out: 'Automatic Check Out',
    not_checked_in: 'You are not currently checked in to a location. Please scan a location QR code below to check in.',
    please_click_continue: 'Please click the button below to be redirected to make a public reservation.',
    please_contact_location: 'Please contact the location you are trying to reserve with if you think this message is in error.',
    location_check_in_error: 'Unknown Location',
    location_check_in_error_message: 'You have scanned an unknown location. Please click the button below to try again.',
    location_check_out_error: 'We encountered an error',
    location_check_out_error_message:
      'Sorry, we encountered an error when trying to check you out of the location. Please click the button below to try again.',
    visit_type: 'Visit Type',
    select_visit_type: 'Select Visit Type',
    visit_type_not_allowed: 'Visit type is not allowed',
  },
  html: {
    temperature_taken: 'have my <strong>temperature taken</strong>',
    masks_required: 'use a <strong>personal protective mask</strong>',
  },
};
